import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hy-profile-menu d-flex no-wrap align-center" }
const _hoisted_2 = { class: "username text-h6 font-weight-bold text-white py-2 pl-6 pr-2 border-s-md border-surface-bright" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppProfileMenu',
  setup(__props) {


const user = useUserStore()

async function handleLogout() {
  await user.logout()
  navigateTo({ name: 'login', query: { logout: 'true' } })
  Notify.info('You have been logged out.')
}


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(user).name), 1),
    _createVNode(_component_v_menu, {
      location: "bottom",
      offset: "10"
    }, {
      activator: _withCtx(({ props: menu }) => [
        _createVNode(_component_v_btn, _mergeProps({
          icon: "",
          large: ""
        }, menu, { class: "mr-4" }), {
          default: _withCtx(() => [
            (_unref(user).loggedIn)
              ? (_openBlock(), _createBlock(_component_v_avatar, {
                  key: 0,
                  color: "primary",
                  size: "45"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _unref(user).avatar
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_hy_icon, {
                  key: 1,
                  name: "User",
                  large: ""
                }))
          ]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              title: "Profile",
              to: { name: 'contact-edit', params: { slug: _ctx.$user.contact.slug } },
              "prepend-icon": "fa fa-user"
            }, null, 8, ["to"]),
            _createVNode(_component_v_list_item, {
              title: "Logout",
              "prepend-icon": "fa fa-right-from-bracket",
              onClick: handleLogout
            }),
            _createVNode(_component_v_list_item, {
              "min-height": "10",
              class: "px-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_divider)
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              title: "Release Notes",
              "prepend-icon": "fa fa-circle-info",
              to: { name: 'release-notes' }
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})